/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, IconButton, useMediaQuery } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import templateStyles from './Template.style';
import { getCustomAttribute, setSelectedTemplate } from './Template.actions';
import { useDispatch, useSelector } from 'react-redux';
import LeftPanel from './left-panel/LeftPanel.component';
import RightPanel from './quick-report';
import { UserPortalContext } from 'context/appcontext';
import LoadingPage from 'components/LoadingPage/LoadingPage';
import ErrorPage from '../Shared/ErrorPage';
import { FEATURES } from 'helper/basicFeatureFlag';
import { CUSTOM_SHOW_TOOLTIP } from 'constants/constant';

export default function Template() {
	const classes = templateStyles();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [show, setShow] = useState(false);
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType } = portalUserContext;
	const [isTooltipCheck, setIsTooltipCheck] = useState(true);
	const { templateErrorCode, templateLoading } = useSelector((state) => state.templateReducer);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const isSmallScreen = useMediaQuery('(max-width:600px)');
	const { catManUser, userPersona, companyName } = userDetails?.result;
	// eslint-disable-next-line prettier/prettier
	const { DISABLE_CUSTOM_ATTRIBUTE: disableGetCustomAttribute } =
		FEATURES[customerType].TEMPLATE_PAGE;

	const loadPage = () => {
		if (disableGetCustomAttribute) {
			// To restrict Custom Attribute call for specific user type(for ex: Basic users)
			return;
		}
		/** below line to keep same variable name. Later, we can change it */
		const selectedPersona = userPersona;
		dispatch(getCustomAttribute({ catManUser, companyName, selectedPersona }));
	};

	useEffect(() => {
		/** if user hit browser refresh on template page */
		if (!templateLoading && templateData?.length === 0) {
			navigate('/');
		}
	}, []);

	const handleClose = () => {
		if ([null, 'false'].includes(localStorage.getItem(CUSTOM_SHOW_TOOLTIP))) {
			localStorage.setItem(CUSTOM_SHOW_TOOLTIP, isTooltipCheck);
		}
		dispatch(setSelectedTemplate({ templateId: null, view: null, filter: undefined }));
		navigate('/');
	};

	if (templateErrorCode >= 400) {
		return (
			<Box className={classes.errorContainer}>
				<ErrorPage
					isSmallScreen={isSmallScreen}
					reload={() => {
						loadPage();
					}}
				/>
			</Box>
		);
	}

	return templateLoading ? (
		<LoadingPage />
	) : (
		<Box>
			<Box className={classes.crossIcon}>
				<IconButton
					aria-label="Close"
					id="clear"
					onClick={() => {
						handleClose();
					}}>
					<CloseIcon fontSize="medium" />
				</IconButton>
			</Box>
			<div className={classes.root}>
				<Grid container direction="row">
					<Grid container>
						<Grid item xs={12} sm={6} md={8} lg={9}>
							<LeftPanel setShow={setShow} show={show} />
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<RightPanel
								setShow={setShow}
								show={show}
								setIsTooltipCheck={setIsTooltipCheck}
								isTooltipCheck={isTooltipCheck}
							/>
						</Grid>
					</Grid>
				</Grid>
			</div>
		</Box>
	);
}
